export default class PdfTemplatePreview {
    constructor(template, canvas) {
        this.template = template;
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
    }

    draw(width, height) {
        this.canvas.width = width;
        this.canvas.height = height;
        this.scale = 0.8 * Math.min(
            height / (parseInt(this.template.height) + parseInt(this.template.margin_top)),
            width / (parseInt(this.template.width) + parseInt(this.template.margin_left)));
        this.ctx.scale(1 * this.scale, 1 * this.scale);
        this.ctx.lineWidth = 1 / this.scale;
        this.ctx.beginPath();
        this.drawLabel();
        this.drawTexts();
        this.drawBoxes();
        this.drawQrCodes();
        this.drawImages();
        this.ctx.stroke();
    }

    drawLabel() {
        this.ctx.rect(this.template.margin_left, this.template.margin_top, this.template.width, this.template.height);
    }

    drawTexts() {
        this.template.texts.forEach(text => {
            const bold = text.bold ? "bold" : "";
            const italic = text.italic ? "italic" : "";
            const fontSize = text.font_size ? text.font_size / this.scale : "4";
            this.ctx.font = `${bold} ${italic} ${fontSize}px Arial`;
            const x = parseInt(this.template.margin_left) + parseInt(text.x1);
            const y = parseInt(this.template.margin_top) + parseInt(text.y1);
            this.ctx.fillText(text.text, x, y);
        });
    }

    drawBoxes() {
        this.template.boxes.forEach(box => {
            const x = parseInt(box.x1) + parseInt(this.template.margin_left);
            const y = parseInt(box.y1) + parseInt(this.template.margin_top);
            const width = box.width;
            const height = box.height;
            this.ctx.rect(x, y, width, height);
        });
    }

    drawQrCodes() {
        this.template.qr_codes.forEach(qrCode => {
            const x = parseInt(qrCode.x1) + parseInt(this.template.margin_left);
            const y = parseInt(qrCode.y1) + parseInt(this.template.margin_top);
            const width = qrCode.width;
            const height = qrCode.height;
            this.ctx.rect(x, y, width, height);
            this.ctx.font = `4px Arial`;
            this.ctx.fillText("QR", x, y + 3);
        });
    }

    drawImages() {
        this.template.images.forEach(image => {
            const x = parseInt(image.x1) + parseInt(this.template.margin_left);
            const y = parseInt(image.y1) + parseInt(this.template.margin_top);
            const width = image.width;
            const height = image.height;
            this.ctx.rect(x, y, width, height);
            this.ctx.font = `4px Arial`;
            this.ctx.fillText("image", x, y + 3);
        });
    }
}